import {selectablePropertyResolver} from '../utils';
import resolveSelectedProperty from './resolveSelectedProperty';

export default function createUnstableResolvePropertySelectorValue(componentRegistry) {
	return function unstableResolvePropertySelectorValue(propertySelector) {
		return resolveSelectedProperty(
			componentRegistry,
			selectablePropertyResolver,
			propertySelector,
			{}
		);
	};
}
